import { cmsLandingPageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-landing-page-route-path';
import { cmsSimplePageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-simple-page-route-path';
import { promotionsRoutePath } from '@bcf-v2/routes-statics/common/app/paths/promotions-route-path';
import { supportRoutePath } from '@bcf-v2/routes-statics/common/app/paths/support-route-path';
import { bpBetBuilderRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/bp-bet-builder-route-path';
import { liveBettingRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/live-betting-route-path';
import { preMatchesRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/pre-matches-route-path';
import { FooterLink } from '../types';

export const footerLinksFn = (): FooterLink[][] => [
  [
    {
      url: cmsSimplePageRoutePath('about-us'),
      title: $localize`About us`
    },
    {
      url: bpBetBuilderRoutePath(),
      title: $localize`Betbuilder`
    },
    {
      title: $localize`Player Props`,
      bottomSheetKind: 'dst-player-bets'
    }
  ],
  [
    {
      url: preMatchesRoutePath(),
      title: $localize`Sports`
    },
    {
      url: liveBettingRoutePath(),
      title: $localize`Live betting`
    },
    {
      url: promotionsRoutePath(),
      title: $localize`Bonuses`
    }
  ],
  [
    {
      url: cmsLandingPageRoutePath('mobile-application'),
      title: $localize`Mobile application`
    },
    {
      url: cmsLandingPageRoutePath('cash-out'),
      title: $localize`Cashout`
    },
    {
      url: cmsLandingPageRoutePath('vip-club'),
      title: $localize`Vip Club`
    }
  ],
  [
    {
      url: supportRoutePath(),
      title: $localize`Support`
    },
    {
      url: cmsSimplePageRoutePath('terms-and-conditions'),
      title: $localize`Terms and conditions`
    },
    {
      url: cmsSimplePageRoutePath('responsible-gaming'),
      title: $localize`Responsible gaming`
    },
    {
      url: cmsSimplePageRoutePath('privacy-policy'),
      title: $localize`Privacy Policy`
    }
  ]
];
